import config from 'config/config'
import { classNames } from 'lib/utilities'
import React from 'react'
import { Segment } from 'semantic-ui-react'

export default class Placeholder extends React.Component {
  render() {
    const dark = config.theme.dark

    return (
      <Segment
        attached
        className={classNames(['placeholder', 'tiny', dark && 'inverted'])}
        loading
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/Helper/Placeholder.jsx